__turbopack_context__.v({
  "arrow": "InteractiveTable-module___cw9nG__arrow",
});
